import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
const ProgressiveImage = /*#__PURE__*/forwardRef(function ForwardedProgressiveImage({
  id,
  className,
  src,
  alt = '',
  height,
  width,
  shouldLazyLoad = false,
  ...other
}, ref) {
  const loadingType = shouldLazyLoad ? 'lazy' : 'eager';
  return /*#__PURE__*/React.createElement("img", _extends({
    ref: ref,
    className: className,
    id: id,
    src: src,
    alt: alt,
    width: width,
    height: height,
    loading: loadingType
  }, other));
});
export default ProgressiveImage;